import Axios from "@/Axios";

class WorkflowService{

    async getWorkflows(data={}){
        return await Axios.get('wms.wms.api.workflow.get_workflows',{
            params:data
        })
    }
    async createWorkflow(data){
      return await Axios.post('wms.wms.api.workflow.create_workflow',data)
    }
    async updateWorkflow(data) {
        return await Axios.put(`wms.wms.api.workflow.update_workflow`, data)
    }
    async getWorkflow(name) {
        console.log("name")
        return await Axios.get('wms.wms.api.workflow.get_workflow_by_id', { params: { name: name } })
    }
    async deleteWorkflow(section){
        const transformedSection = section.map(item => ({ name: item }));
        return await Axios.delete('wms.wms.api.workflow.delete_workflow',{data:{workflow_name:transformedSection}})
    }

}
export default new WorkflowService()